import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryStaffMembersUpdateFailedAction = {
	type: 'BENEFICIARY_STAFF_MEMBERS_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryStaffMembersUpdateFailedAction => ({
	type: 'BENEFICIARY_STAFF_MEMBERS_UPDATE_FAILED',
	payload,
});
